import Fingerprint2 from 'fingerprintjs2';

export function FingerprintingService($q) {
    const service = this;

    service.getDeviceFingerprint = function getDeviceFingerprint() {
        const defer = $q.defer();

        // These are the components we want to exclude for the fingerprint generation.
        const options = {
            excludes: {
                screenResolution: true,
                availableScreenResolution: true,
                pixelRatio: true
            }
        };

        Fingerprint2.get(options, (components) => {
            // After getting all the components, we map extract all the component values.
            const values = components.map(function(component) {
                return component.value;
            });

            // We are now able to join all the component values with a separator and use the library 
            // function to generate a hash.
            const murmurHash = Fingerprint2.x64hash128(values.join('\n'), 31);

            defer.resolve(murmurHash);
        });

        return defer.promise;
    };

    return service;
}

FingerprintingService.$inject = ['$q'];
